import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Geocode from "react-geocode";
import _ from "lodash";
import { Button } from "@material-ui/core";

import ViewIcon from "@material-ui/icons/RemoveRedEye";

const containerStyle = {
    position: "relative",
    minWidth: "100%",
    height: "50VH",
    minHeight: 250
};
export class InfoWindowEx extends Component {
    constructor(props) {
        super(props);
        this.infoWindowRef = React.createRef();

        if (!this.containerElement) {
            this.containerElement = document.createElement(`div`);
        }
    }

    onInfoWindowOpen = () => {
        ReactDOM.render(
            React.Children.only(this.props.children),
            this.containerElement
        );
        this.infoWindowRef.current.infowindow.setContent(this.containerElement);
    };
    render() {
        return (
            <InfoWindow
                onOpen={this.onInfoWindowOpen}
                ref={this.infoWindowRef}
                {...this.props}
            />
        );
    }
}
class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            lng: 0,
            markerName: "",
            showingInfoWindow: false,
            rep: false,
            activeMarker: {},
            selectedPlace: {}
        };
        Geocode.setApiKey("AIzaSyD2s9vyxwQCR8y7F8pCGFgAvJFJ8inhRTU");
    }

    getMarkers = reports => {
        const { report_titles, users } = this.props;

        if (reports)
            return reports.map((report, i) => {
                let linkTo;
                let reportNotPresent = false;
                let user = _.find(users, { uid: report.uid });
                if (report.subject_name === "reports") {
                    if (
                        report.uid &&
                        report.report_type &&
                        report.subject_child &&
                        report.subject_name
                    ) {
                        linkTo = `report-view-standalone/${
                            report.subject_name
                        }/${report.subject_child}/${report.report_type.replace(
                            /_/g,
                            "-"
                        )}/${report.timestamp
                            .replace(/ /g, "_")
                            .replace(/:/g, ".")}`;
                    } else {
                        linkTo = "/submitted-reports-v2";
                        reportNotPresent = true;
                    }
                } else {
                    if (
                        report.uid &&
                        report.report_type &&
                        report.subject_child &&
                        report.subject_name
                    ) {
                        linkTo = `report-view/${report.subject_name}/${
                            report.subject_child
                        }/${report.report_type.replace(
                            /_/g,
                            "-"
                        )}/${report.timestamp
                            .replace(/ /g, "_")
                            .replace(/:/g, ".")}`;
                    } else {
                        linkTo = "/submitted-reports-v2";
                        reportNotPresent = true;
                    }
                }
                return (
                    <Marker
                        key={i}
                        title={report_titles[report.report_type] + " Report"}
                        position={{
                            lat: report.location_lat,
                            lng: report.location_lon
                        }}
                        name={report_titles[report.report_type] + " Report"}
                        onClick={(props, marker, e) => {
                            let rep = {
                                title: report_titles[report.report_type],
                                timestamp: report.timestamp,
                                user: user.user_name || "N/A"
                            };

                            this.setState({
                                selectedCoord: {
                                    lat: report.location_lat,
                                    lng: report.location_lon
                                },
                                selectedPlace: props,
                                activeMarker: marker,
                                showingInfoWindow: true,
                                rep,
                                reportNotPresent,
                                link: linkTo
                            });
                        }}
                    />
                );
            });
        else return [];
    };
    gotolink = () => {
        this.props.redirectTo(this.state.link);
    };
    render() {
        const { reports } = this.props;
        const { reportNotPresent } = this.state;
        return (
            <div
                ref={"map"}
                style={{ marginTop: 24, width: "100%", height: "100%" }}
            >
                <Map
                    style={{
                        border: "1px solid rgb(195, 207, 214)",
                        minWidth: "100%"
                    }}
                    google={this.props.google}
                    initialCenter={
                        this.state.selectedCoord
                            ? this.state.selectedCoord
                            : {
                                  lat: 53.3020686,
                                  lng: -7.4909908
                              }
                    }
                    zoom={9}
                    center={
                        this.state.selectedCoord
                            ? this.state.selectedCoord
                            : {
                                  lat: 53.3020686,
                                  lng: -7.4909908
                              }
                    }
                    containerStyle={containerStyle}
                    onClick={() => {
                        if (this.state.showingInfoWindow) {
                            this.setState({
                                showingInfoWindow: false,
                                activeMarker: null
                            });
                        }
                    }}
                >
                    {this.getMarkers(reports)}
                    <InfoWindowEx
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                    >
                        <div
                            style={{
                                textAlign: "center",
                                marginTop: 20,
                                padding: 10,
                                width: "100%"
                            }}
                        >
                            <p>
                                <b>Report Type:</b> {this.state.rep.title || ""}
                            </p>
                            <p>
                                <b>Timestamp:</b>{" "}
                                {this.state.rep.timestamp || ""}
                            </p>
                            <p>
                                <b>User Name:</b> {this.state.rep.user || ""}
                            </p>

                            <Button
                                disable={reportNotPresent}
                                style={{
                                    width: "100%"
                                }}
                                variant="contained"
                                color="primary"
                                onClick={this.gotolink}
                            >
                                View <ViewIcon style={{ marginLeft: 5 }} />
                            </Button>
                        </div>
                    </InfoWindowEx>
                </Map>
            </div>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyD2s9vyxwQCR8y7F8pCGFgAvJFJ8inhRTU"
})(MapContainer);
